import Vue from "vue";
import Vuex from "vuex";

import router from "@/routes";

import { alert } from "./alertModule";
import { appBar } from "./appBarModule.js";
import { authentication } from "./authenticationModule";
import { drawer } from "./drawerModule";
import { load } from "./loadModule.js";
import { localisation } from "./localisationModule";
import { hub } from "./hubModule.js";
import { schema } from "./schemaModule";
import { chat } from "./chatModule";
import { workerLikes } from "./workerLikesModule"

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        alert,
        appBar,
        authentication,
        drawer,
        load,
        localisation,
        hub,
        schema,
        chat,
        workerLikes
    },
    state: {
        // Adding router to the root store to support reactivity in Vuex getters (currentRoute).
        router: router
    },
    getters: {
        schema: state => state.schema.schema,
    },
});

// Watching isLoggedIn to load other Vuex modules.
store.watch(
    state => state.authentication.isLoggedIn,
    isLoggedIn => store.dispatch('load/onLoginChange', isLoggedIn));

export default store;
